module.exports = __webpack_public_path__ + "static/img/money-active@2x.2df6ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/money-active@2x.png
// module id = ZaBU
// module chunks = 1